export default class ScrollGradient {
    constructor(el) {
        this.DOM = { el: el };
        this.startSelector = this.DOM.el.dataset.scrollStartSelector || '[data-scroll-start]';
        this.endSelector = this.DOM.el.dataset.scrollEndSelector || '[data-scroll-end]';
        this.DOM.scrollStart = this.DOM.el.querySelector(this.startSelector);
        this.DOM.scrollEnd = this.DOM.el.querySelector(this.endSelector);

        this.initEvents();
    }
    initEvents() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                let className = '';

                if (entry.target === this.DOM.scrollStart) {
                    className = 'scroll-start';
                } else if (entry.target === this.DOM.scrollEnd) {
                    className = 'scroll-end';
                }

                this.DOM.el.classList[entry.isIntersecting ? 'add' : 'remove'](className);
            })
        }, {
            root: this.DOM.el,
            rootMargin: '1px',
        });

        observer.observe(this.DOM.scrollStart);
        observer.observe(this.DOM.scrollEnd);
    }
}

const scrollElements = Array.from(document.querySelectorAll('[data-scroll-gradient]'));
if (scrollElements !== null) {
    scrollElements.forEach((element) => new ScrollGradient(element));
}
